export default {
  title: 'Sign In',
  emailPH: 'Email',
  pwdPH: 'Password',
  submitTxt: 'Login',
  busyTxt: 'Please wait...',
  errMsg: 'The login failed - please check your inputs!',
  registerHint1: 'Don\'t have an account yet?',
  registerHint2: 'Register here'
}
